module.exports = __webpack_public_path__ + "static/img/fmap.5ca1265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theresource/IdcFudi/fmap.png
// module id = oQtl
// module chunks = 0